import { headerDock } from "./modules/header-docking";
import { footerMenu } from "./modules/footer";
import { headerSearchIcon } from "./modules/header-search-icon";
import { backButtonFunctionality } from "./modules/go-back-button";
import { highlightSearchTerms } from './modules/highlight-search';
import { selectField } from "./modules/form-select-field";

document.addEventListener( 'DOMContentLoaded', function() {
    headerDock();
    footerMenu();
    headerSearchIcon() 
    backButtonFunctionality();
    highlightSearchTerms();
    selectField();
  }
);


